<template>
  <div class="home">
    <innerHeader v-if="!isMobile"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <!--cloumnId控制contentList  Tab的active -->
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="7"
          v-if="!isMobile"
          class="bg"
        >
          <div slot="main_content">
            <div class="content_top" v-if="list.length">
              <div class="article_con">
                <el-input
                  :placeholder="$t('searchInfor')"
                  v-model="value"
                  id="search_input"
                >
                  <div slot="prefix" class="search_icon">
                    <img src="../../assets/img/search_icon.png" />
                  </div>
                  <div slot="suffix" class="search_btn_con">
                    <i
                      v-if="value != ''"
                      slot="suffix"
                      class="el-input__icon el-icon-circle-close"
                      @click="value = ''"
                      style="font-size: 16px"
                    ></i>
                    <div class="search_btn" @click="getList">
                      {{ $t('search') }}
                    </div>
                  </div>
                </el-input>
                <div class="tuijian" v-if="!showResult">
                  <div class="tuijian_title">{{ $t('searchHistory') }}</div>
                  <div class="tuijian_item">
                    <div
                      :class="[
                        'tj_one',
                        tuijianActive == index ? 'active' : '',
                      ]"
                      v-for="(t, index) in tuijianData"
                      :key="index"
                      @click="handletuijian(t, index)"
                    >
                      {{ t }}
                    </div>
                  </div>
                </div>
                <div class="search_res" v-else>
                  <el-divider content-position="center"
                    >{{ $t('total')
                    }}<span>{{ page.total }}{{ $t('items') }}</span
                    >{{ $t('searchItems') }}</el-divider
                  >
                  <div
                    class="res_item"
                    v-for="(r, index) in result"
                    :key="index"
                    @click="toPage(r)"
                  >
                    <div class="res_title">{{ r.title }}</div>
                    <div class="res_con detail_con">{{ r.contentNew }}</div>
                    <div class="line"></div>
                  </div>
                  <paginations
                    :current-page.sync="page.current"
                    @current-change="currentChange"
                    :page-size="page.size"
                    :total="page.total"
                  ></paginations>
                </div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div>
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="7"
          v-if="isMobile"
          class="appbg"
        >
          <div slot="main_content">
            <div class="app_content_top">
              <div class="article_con">
                <div class="article_con">
                  <el-input
                    :placeholder="$t('searchInfor')"
                    v-model="value"
                    id="search_input"
                  >
                    <div slot="prefix" class="search_icon">
                      <img src="../../assets/img/appImg/search_icon2.png" />
                    </div>
                    <!-- <div slot="suffix" class="search_btn" getList>搜索</div> -->
                    <div slot="suffix" class="search_btn_con">
                      <i
                        v-if="value != ''"
                        slot="suffix"
                        class="el-input__icon el-icon-circle-close"
                        @click="value = ''"
                        style="font-size: 12px"
                      ></i>
                      <div class="search_btn" @click="getList">
                        {{ $t('search') }}
                      </div>
                    </div>
                  </el-input>
                  <div class="tuijian" v-if="!showResult">
                    <div class="tuijian_title">{{ $t('searchHistory') }}</div>
                    <div class="tuijian_item">
                      <div
                        :class="[
                          'tj_one',
                          tuijianActive == index ? 'active' : '',
                        ]"
                        v-for="(t, index) in tuijianData"
                        :key="index"
                        @click="handletuijian(t, index)"
                      >
                        {{ t }}
                      </div>
                    </div>
                  </div>
                  <div class="search_res" v-else>
                    <el-divider content-position="center"
                      >{{ $t('total')
                      }}<span>{{ result.length }}{{ $t('items') }}</span
                      >{{ $t('searchItems') }}</el-divider
                    >
                    <div
                      class="res_item"
                      v-for="(r, index) in result"
                      :key="index"
                      @click="toPage(r)"
                    >
                      <div class="res_title">{{ r.title }}</div>
                      <div class="res_con app_detail_con">
                        {{ r.contentNew }}
                      </div>
                      <div class="line"></div>
                    </div>
                    <paginations
                      :current-page.sync="page.current"
                      @current-change="currentChange"
                      :page-size="page.size"
                      :total="page.total"
                    ></paginations>
                  </div>
                </div>
              </div>
            </div></div
        ></AppcontentList>
        <!-- <paginations
          :current-page.sync="page.current"
          @current-change="currentChange"
          :page-size="page.size"
          :total="page.total"
        ></paginations> -->
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <innerAppFooter v-else />
  </div>
</template>

<script>
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import innerAppFooter from '@/components/innerAppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { searchTab } from '@/const';
import { getSearch } from '@/assets/api';
import { getSearchValue, setSearchValue } from '@/assets/api/token';
export default {
  name: 'FullSearch',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    innerAppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
  },
  data() {
    return {
      contentBg: require('../../assets/img/homeimgs/presi_bg.png'),
      contentBg2: require('../../assets/img/appImg/presi_bg.png'),
      tabList: searchTab,
      value: '',
      page: { current: 1, size: 10, total: 20 },
      tuijianActive: null,
      cloumnId: null, //栏目id
      tuijianData: JSON.parse(getSearchValue()),

      list: [
        {
          title: '似是闯入梦',
          img: require('../../assets/img/activity_img4.png'),
          id: 1,
        },
        {
          title: '似是闯入梦',
          img: require('../../assets/img/activity_img4.png'),
          id: 2,
        },
        {
          title: '似是闯入梦幻地心世界',
          img: require('../../assets/img/activity_img4.png'),
          id: 3,
        },
        {
          title: '似是闯入',
          img: require('../../assets/img/activity_img4.png'),
          id: 4,
        },
        {
          title: '梦幻地心世界',
          img: require('../../assets/img/activity_img4.png'),
          id: 5,
        },
        {
          title: '地心世界',
          img: require('../../assets/img/activity_img4.png'),
          id: 6,
        },
      ],
      showResult: false,
      result: [
        // {
        //   name: '乌镇戏剧节  小镇图书馆 图书捐赠特别鸣谢',
        //   value:
        //     '在乌镇戏剧节小镇图书馆，不仅拥有丰富的藏书，更汇聚了一群热爱书籍的灵魂。这里白日是戏剧节热闹中的安静一隅，有由全国五十六家出版社/图书公司捐赠的，汇聚古今中外名家经典的图书供大家阅读；夜晚是子夜朗读会的举办地，无论何人，只要心中怀有对文字的…',
        // },
      ],
      id: '',
    };
  },
  mounted() {
    this.tabList.name = this.$t('fullSearch');
  },
  methods: {
    handletuijian(v, index) {
      this.value = v;
      this.tuijianActive = index;
    },
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.path });
      // this.getList();
    },
    currentChange(e) {
      this.page.current = e;
      this.getList();
    },
    getList() {
      if (this.value != '') {
        let sData = JSON.parse(getSearchValue()) || [];
        sData.unshift(this.value);

        const uniqueArray = [...new Set(sData)];
        setSearchValue(uniqueArray);
        this.tuijianData = uniqueArray;
        let data = {
          current: this.page.current,
          size: this.page.size,
          match: this.value,
        };
        getSearch(data).then((res) => {
          if (res.code == 200) {
            this.showResult = true;
            this.result = res.data.records;

            this.page.total = res.data.total;
            this.result = this.result.map((r) => {
              // 1. 提取第一段内容
              const firstParagraph =
                r.content && r.content.split('</p>')[0] + '</p>';

              // 2. 移除所有HTML标签
              let textOnly =
                firstParagraph && firstParagraph.replace(/<[^>]*>/g, '');

              // 3. 移除HTML实体字符（如 &zwnj; &nbsp; 等）
              textOnly = textOnly && textOnly.replace(/&[a-z]+;/g, '');

              // 4. 去除开头的空格和全角空格
              const cleanText =
                textOnly && textOnly.trim().replace(/^[\s　]+/, '');

              // 5. 以句号分割文本并取第一句（保留句号）
              const firstSentence =
                cleanText && cleanText.split('。')[0] + '。';
              r.contentNew = firstSentence;
              return r;
            });
          }
        });
      } else {
        this.showResult = false;
        this.result = [];
        this.page.total = 0;
      }
    },
    toPage(row) {
      this.$router.push({
        path: row.accessPath,
        query: { id: row.id, cloumnId: row.columnId },
      });
    },
    toDetail(id) {
      this.$router.push({ path: `/theaterDetail?id=${id}` });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 1.5rem 0;
    .article_con {
      width: 100%;
      box-sizing: border-box;
      .search_icon {
        margin: 30px;
        width: 34px;
        margin: 23px 30px;
      }
      .search_btn_con {
        display: flex;
        align-items: center;
        .search_btn {
          margin: 0.5rem;
          width: 150px;
          height: 4rem;
          background: #6b6d7a;
          border-radius: 200px;
          font-size: 1.5rem;
          color: #fff;
          line-height: 4rem;
          cursor: pointer;
        }
      }

      .tuijian {
        .tuijian_title {
          font-size: 20px;
          margin-top: 2rem;
          color: #424451;
        }
        .tuijian_item {
          margin-top: 1.25rem;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 20px; /* 设置间距 */

          .tj_one {
            width: calc(100% / 7);
            background: #f0f1f2;
            border-radius: 12.5rem;
            height: 3rem;
            line-height: 3rem;
            text-align: center;
            cursor: pointer;
            white-space: nowrap;
            overflow: hidden; /* 隐藏溢出 */
            text-overflow: ellipsis;
            &.active {
              background: #6b6d7a;
              color: #fff;
            }
          }
          &::after {
            content: '';
            flex: auto;
            width: calc(100% / 7);
            /* 或者使用固定宽度，与项目宽度相同 */
            /* width: 30%; */
          }
        }
      }
      .search_res {
        margin-top: 2rem;
        overflow: hidden;
        span {
          color: #6a1211;
        }
        .res_item {
          cursor: pointer;
          .res_title {
            font-size: 1.125rem;
            font-family: SourceHanSansCN-Medium;
            margin: 2rem 0 1rem;
          }
          .res_con {
            color: #6b6d7a;
            font-size: 1.125rem;
            line-height: 2.5rem;
            display: -webkit-box; /* 旧版 Flex 布局 */
            -webkit-line-clamp: 2; /* 限制行数 */
            -webkit-box-orient: vertical; /* 垂直排列 */
            overflow: hidden; /* 隐藏溢出 */
            text-overflow: ellipsis;
          }
          .line {
            width: 100%;
            margin: 0.75rem 0 0;
            height: 0.0625rem;
            background: linear-gradient(
              to right,
              rgba(170, 229, 239, 1),
              rgba(177, 187, 255, 1)
            );
          }
        }
      }
    }
  }

  .app_content_top {
    padding: 2rem 0;
    box-sizing: border-box;
    .article_con {
      // background: #fff;
      width: 100%;
      box-sizing: border-box;

      .search_icon {
        margin: 1.3333rem;
        width: 1.3333rem;
        margin: 1.3333rem;
      }
      .search_btn_con {
        display: flex;
        align-items: center;
        .search_btn {
          margin: 0.4167rem;
          width: 5.9167rem;
          height: 3.1667rem;
          background: #6b6d7a;
          border-radius: 200px;
          font-size: 1.5rem;
          color: #fff;
          line-height: 3.1667rem;
          cursor: pointer;
        }
      }
      .tuijian {
        min-height: 48.6vh;
        .tuijian_title {
          font-size: 1.3333rem;
          margin-top: 2.5rem;
          color: #424451;
        }
        .tuijian_item {
          margin-top: 1.25rem;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 5px; /* 设置间距 */

          .tj_one {
            width: calc(100% / 4);
            // background: #f0f1f2;
            border-radius: 12.5rem;
            height: 3rem;
            line-height: 3rem;
            text-align: center;
            cursor: pointer;
            padding: 0 0.4167rem;
            white-space: nowrap;
            overflow: hidden; /* 隐藏溢出 */
            text-overflow: ellipsis;
            &.active {
              background: #6b6d7a;
              color: #fff;
            }
          }
          &::after {
            content: '';
            flex: auto;
            width: calc(100% / 4);
            /* 或者使用固定宽度，与项目宽度相同 */
            /* width: 30%; */
          }
        }
      }
      .search_res {
        margin-top: 1rem;
        overflow: hidden;
        span {
          color: #6a1211;
        }
        .res_item {
          .res_title {
            font-size: 1rem;
            font-family: SourceHanSansCN-Medium;
            margin: 0.6667rem 0 1rem;
          }
          .res_con {
            color: #6b6d7a;
            font-size: 1rem;
            line-height: 1.8333rem;
            display: -webkit-box; /* 旧版 Flex 布局 */
            -webkit-line-clamp: 2; /* 限制行数 */
            -webkit-box-orient: vertical; /* 垂直排列 */
            overflow: hidden; /* 隐藏溢出 */
            text-overflow: ellipsis;
          }
          .line {
            width: 100%;
            margin: 0.75rem 0 0;
            height: 0.0625rem;
            background: linear-gradient(
              to right,
              rgba(170, 229, 239, 1),
              rgba(177, 187, 255, 1)
            );
          }
        }
      }
    }
  }
}
::v-deep {
  .content_top {
    #search_input.el-input__inner {
      background: #f0f0f0;
      border-radius: 94px;
      height: 5rem;
      padding-left: 4.75rem;
      border: none;
      font-size: 1.5rem;
    }
    #search_input::placeholder {
      color: #6b6d7a; /* 修改颜色 */
      font-size: 1.5rem; /* 修改字体大小 */
      line-height: 4rem;
    }

    .el-divider__text {
      background: none;
      font-size: 1.125rem;
    }
  }
  .app_content_top {
    #search_input.el-input__inner {
      background: #f0f0f0;
      border-radius: 94px;
      height: 4rem;
      padding-left: 3.3333rem;
      border: none;
      font-size: 1.1667rem;
    }
    #search_input::placeholder {
      color: #6b6d7a; /* 修改颜色 */
      font-size: 1.1667rem; /* 修改字体大小 */
      line-height: 4rem;
    }
    .el-divider__text {
      background: none;
      font-size: 1.125rem;
    }
  }
}
.appbg {
  width: 100%;
  background: url('../../assets/img/appImg/article_bg.png') no-repeat left
    bottom/100% auto;
}
.bg {
  width: 100%;
  // background: url('../../assets/img/homeimgs/article_bg.png') no-repeat left
  //   bottom/100% auto;
  background: url('../../assets/img/homeimgs/article_bg.png') fixed;
}
</style>
